
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.466 8.158l-6.438 6.438c-.466.466-.451.734-.434 1.036.039.666.083 1.43-1.458 2.971a.184.184 0 00-.052.13c0 .049.017.096.051.131a.192.192 0 00.132.052.184.184 0 00.13-.052c1.54-1.54 2.305-1.497 2.971-1.458.302.017.57.032 1.036-.434l6.415-6.415c-.793-.787-1.576-1.606-2.353-2.4zm3.129 3.155L6.17 17.737c-.808.809-1.304.78-1.861.748-.441-.026-.947-.055-2.146 1.144a1.264 1.264 0 01-1.792 0 1.27 1.27 0 010-1.791c1.199-1.2 1.17-1.706 1.144-2.147-.032-.557-.06-1.053.748-1.861l6.442-6.443c-.17-.18-.359-.358-.535-.534a1.753 1.753 0 01-.03-2.442l.03-.034a1.748 1.748 0 012.475 0l.144.144 3.55-3.552A3.317 3.317 0 0116.684 0 3.31 3.31 0 0120 3.316c0 .849-.323 1.7-.969 2.345l-3.55 3.55.142.142a1.753 1.753 0 01-1.238 2.988c-.433 0-.867-.16-1.204-.48-.196-.18-.392-.363-.586-.548zm-3.11-4.675c1.474 1.475 3.008 2.94 4.447 4.447a.666.666 0 00.453.173.667.667 0 00.472-.194.667.667 0 00.194-.473.67.67 0 00-.193-.473l-.525-.524a.541.541 0 010-.765c1.327-1.236 2.644-2.643 3.932-3.933a2.228 2.228 0 00.651-1.58 2.228 2.228 0 00-2.231-2.232c-.574 0-1.148.216-1.582.65L11.17 5.666a.54.54 0 01-.761 0l-.525-.524a.67.67 0 00-.475-.194.667.667 0 00-.472.194l-.02.019a.67.67 0 00-.174.453.67.67 0 00.193.473l.55.55z","fill":"#1E1E1E"}})])
          )
        }
      }
    